import CollectionTableFilter from './collection-table-filter';

export default CollectionTableFilter;